'use client';

import Image from 'next/image';

import LogoWatermark from '../../../public/images/logo-symbol-watermark.svg';
import LogoWatermarkGreen from '../../../public/images/logo-symbol-watermark-green.svg';

type CardColor = 'primary' | 'light-green' | 'light-grey';
export type TeamMember = {
    avatar: string;
    name: string;
    caption: string;
    quote: string;
    video: string;
    position: number;
};

type Props = {
    members: [TeamMember, TeamMember];
    colors: [CardColor, CardColor];
};

export function DuoTeamMember({ members, colors }: Props) {
    const renderImage = (member: TeamMember) => (
        <Image
            src={`/images/campaigns/30years/${member.avatar}`}
            alt={member.name}
            className={`absolute object-contain object-right pt-32 md:pt-10 lg:pt-24 xl:pt-10`}
            fill
        />
    );

    const renderQuote = (member: TeamMember) => (
        <div className="w-2/3 pt-12 lg:pr-20 xl:pt-16 xl:pr-48">
            <q className="font-display text-2xl md:text-3xl">{member.quote}</q>
            <p className="mt-8 font-bold">{member.name}</p>
            <p className="">{member.caption}</p>
        </div>
    );

    const bgColor = (color: CardColor) => {
        switch (color) {
            case 'primary':
                return 'bg-primary';
            case 'light-green':
                return 'bg-light-green';
            default:
                return 'bg-light-grey';
        }
    };

    const textColor = (color: CardColor) => {
        return color === 'primary' ? 'text-white' : '';
    };

    const watermark = (color: CardColor) => {
        const className = 'mx-auto mt-10';
        return color === 'primary' ? (
            <LogoWatermarkGreen className={className} />
        ) : (
            <LogoWatermark className={className} />
        );
    };

    return (
        <div className="relative overflow-hidden">
            <div className={`absolute top-0 bottom-1/2 left-0 w-full lg:bottom-0 lg:w-1/2 ${bgColor(colors[0])}`}>
                {watermark(colors[0])}
                {renderImage(members[0])}
            </div>
            <div className={`absolute top-1/2 right-0 bottom-0 w-full lg:top-0 lg:w-1/2 ${bgColor(colors[1])}`}>
                {watermark(colors[1])}
                {renderImage(members[1])}
            </div>
            <div className="relative container mx-auto flex flex-col p-4 lg:flex-row">
                <div className={`relative h-[300px] lg:w-1/2 ${textColor(colors[0])}`}>{renderQuote(members[0])}</div>
                <div
                    className={`lg:ml-margin-semi-container left-1/2 h-[300px] lg:absolute lg:w-1/2 ${textColor(
                        colors[1],
                    )}`}>
                    {renderQuote(members[1])}
                </div>
            </div>
        </div>
    );
}
